//--- ARQUIVO COMPLETO E ATUALIZADO: DashboardView.js (Cards Enriquecidos e Circulares) ---
import React, { useMemo, useState } from 'react';
import { CircularProgressBar } from './CircularProgressBar.js'; // Importa o novo componente
import { DollarSignIcon, TrendingUpIcon, TrendingDownIcon, AlertCircleIcon, AlertTriangleIcon, TargetIcon, InfoIcon, FileTextIcon } from './Icons.js'; //

const LIMITE_ANUAL_MEI = 81000.00;

const Tooltip = ({ text }) => ( <div className="relative group flex items-center"><span className="ml-2 text-blue-500 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 transition-colors"><InfoIcon /></span><div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 p-2 bg-gray-800 text-white text-xs rounded-md shadow-lg opacity-0 group-hover:opacity-100 transition-opacity z-10 pointer-events-none">{text}</div></div> ); //

export const DashboardView = ({ transactions, meiInfo, onCardClick, dasPayments }) => { //
    const [activePeriod, setActivePeriod] = useState('this_month'); //
    const formatCurrency = (value) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value); //

    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();

    const dashboardData = useMemo(() => {
        const today = new Date(); today.setHours(0, 0, 0, 0); const currentDay = today.getDate(); //
        const sevenDaysFromNow = new Date(today); sevenDaysFromNow.setDate(today.getDate() + 7); //

        const periodTransactions = activePeriod === 'all' ? transactions : transactions.filter(t => { const tDate = new Date(t.data + 'T00:00:00'); const tYear = tDate.getFullYear(); const tMonth = tDate.getMonth(); if (activePeriod === 'this_month') return tYear === year && tMonth === month; if (activePeriod === 'last_month') { const lastMonthDate = new Date(year, month, 0); return tYear === lastMonthDate.getFullYear() && tMonth === lastMonthDate.getMonth(); } if (activePeriod === 'this_year') return tYear === year; return false; }); //
        
        let periodReceitas = 0, periodDespesas = 0, periodAportes = 0, periodRetiradas = 0;
        periodTransactions.forEach(t => { //
            if (t.status === 'pago') {
                switch(t.tipo) {
                    case 'receita': periodReceitas += t.valor; break;
                    case 'despesa': periodDespesas += t.valor; break;
                    case 'aporte': periodAportes += t.valor; break;
                    case 'retirada': periodRetiradas += t.valor; break;
                    default: break;
                }
            } else {
                 if (t.tipo === 'aporte') periodAportes += t.valor;
                 if (t.tipo === 'retirada') periodRetiradas += t.valor;
            }
        });
        
        const periodLucro = periodReceitas - periodDespesas; //
        const periodCaixa = (periodReceitas + periodAportes) - (periodDespesas + periodRetiradas); //
        
        let aReceber = 0, aPagar = 0;
        let aReceberVencidoCount = 0, aPagarVencidoCount = 0, aPagarProximoCount = 0;
        let aReceberVencidoValor = 0, aPagarVencidoValor = 0, aPagarProximoValor = 0;
        let aReceberProximoValor = 0;
        let totalReceitasAno = 0;

        transactions.forEach(t => {
            if (t.tipo === 'receita') {
                const yearCheckDateStr = t.data || t.vencimento; // Faturamento (competência)
                if (yearCheckDateStr && new Date(yearCheckDateStr + 'T00:00:00').getFullYear() === year) {
                     totalReceitasAno += t.valor; //
                }
            }
            
            if (t.status === 'pendente') {
                const vencimento = t.vencimento ? new Date(t.vencimento + 'T00:00:00') : null;
                
                if (t.tipo === 'receita') {
                    aReceber += t.valor; //
                    if (vencimento && vencimento < today) {
                        aReceberVencidoCount++; //
                        aReceberVencidoValor += t.valor;
                    } 
                    else if (vencimento && vencimento >= today && vencimento <= sevenDaysFromNow) {
                        aReceberProximoValor += t.valor;
                    }
                } else if (t.tipo === 'despesa') {
                    aPagar += t.valor; //
                    if (vencimento && vencimento < today) {
                        aPagarVencidoCount++; //
                        aPagarVencidoValor += t.valor;
                    } else if (vencimento && vencimento >= today && vencimento <= sevenDaysFromNow) {
                        aPagarProximoCount++; //
                        aPagarProximoValor += t.valor;
                    }
                }
            }
        }); 

        let dasAlert = null; //
        if (dasPayments && currentDay >= 1 && currentDay <= 20) { //
            const lastMonthDate = new Date(year, month, 0); //
            const lastMonthNameLower = lastMonthDate.toLocaleString('pt-BR', { month: 'long' }).toLowerCase(); //
            const paymentsForYear = dasPayments; //
             if (paymentsForYear && paymentsForYear[lastMonthNameLower]?.status === 'pendente') { //
                 const lastMonthNameDisplay = lastMonthDate.toLocaleString('pt-BR', { month: 'long' }); //
                 dasAlert = `A guia do DAS de ${lastMonthNameDisplay} vence dia 20! Não se esqueça de gerar e pagar.`; //
             }
        }

        const dataAbertura = meiInfo.dataAbertura ? new Date(meiInfo.dataAbertura + 'T00:00:00') : new Date(year, 0, 1); //
        const mesesAtividade = dataAbertura.getFullYear() < year ? 12 : (12 - dataAbertura.getMonth()); //
        const limiteProporcional = (LIMITE_ANUAL_MEI / 12) * mesesAtividade; //
        const percentualAtingido = limiteProporcional > 0 ? (totalReceitasAno / limiteProporcional) * 100 : 0; //
        let goal = 0, title = '', metaPercentual = 0; //
        if (activePeriod !== 'all' && meiInfo.monthlyGoal > 0) { //
            const numMonthsInPeriod = activePeriod === 'this_year' ? 12 : 1; //
             goal = meiInfo.monthlyGoal * numMonthsInPeriod; //
             title = activePeriod === 'this_year' ? 'Meta de Faturamento Anual' : 'Meta de Faturamento Mensal'; //
             metaPercentual = goal > 0 ? (periodReceitas / goal) * 100 : 0; //
        }

        return {
            periodReceitas, periodDespesas, periodLucro, periodCaixa,
            aReceber, aPagar,
            aReceberVencido: aReceberVencidoCount,
            aPagarVencido: aPagarVencidoCount,
            aPagarProximo: aPagarProximoCount,
            aReceberVencidoValor,
            aPagarVencidoValor,
            aPagarProximoValor,
            aReceberProximoValor,
            totalReceitasAno, limiteProporcional, percentualAtingido, dasAlert,
            metaConfig: { goal, title, metaPercentual }
        };
    }, [transactions, activePeriod, meiInfo, dasPayments, year, month]);

    const {
        periodReceitas, periodDespesas, periodLucro, periodCaixa,
        aReceber, aPagar, aReceberVencido, aPagarVencido, aPagarProximo,
        aReceberVencidoValor, aPagarVencidoValor, aPagarProximoValor, aReceberProximoValor,
        totalReceitasAno, limiteProporcional, percentualAtingido, dasAlert, metaConfig
    } = dashboardData;
    
    const showAlerts = aReceberVencido > 0 || aPagarVencido > 0 || aPagarProximo > 0 || dasAlert; //

    const FilterButton = ({ period, children }) => { const isActive = activePeriod === period; const baseClasses = "px-3 py-1 text-sm font-medium rounded-md transition-colors"; const activeClasses = "bg-blue-600 text-white"; const inactiveClasses = "bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-300 dark:hover:bg-gray-600"; return <button onClick={() => setActivePeriod(period)} className={`${baseClasses} ${isActive ? activeClasses : inactiveClasses}`}>{children}</button>; }; //

    return (
        <>
            <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-200 mb-4">Visão Geral</h2>

            {/* 1. Filtros */}
            <div className="mb-6 flex space-x-2 flex-wrap gap-2"> {/* */}
                <FilterButton period="this_month">Este Mês</FilterButton> {/* */}
                <FilterButton period="last_month">Mês Passado</FilterButton> {/* */}
                <FilterButton period="this_year">Este Ano</FilterButton> {/* */}
                <FilterButton period="all">Todo o Período</FilterButton> {/* */}
            </div>

            {/* 2. Avisos Importantes */}
            {showAlerts && ( //
                <div className="mb-6 bg-yellow-50 dark:bg-yellow-900/20 border-l-4 border-yellow-400 p-4 rounded-md shadow"> {/* */}
                    <h3 className="font-bold text-yellow-800 dark:text-yellow-300">Avisos Importantes</h3> {/* */}
                    <div className="text-sm text-yellow-700 dark:text-yellow-200 mt-2 space-y-1"> {/* */}
                        {dasAlert && (<div className="flex items-center"><FileTextIcon size={18}/><span className="ml-2"><strong>{dasAlert}</strong></span></div>)} {/* */}
                        {aReceberVencido > 0 && ( <div onClick={() => onCardClick('receitas_vencidas')} className="flex items-center cursor-pointer hover:underline"><AlertTriangleIcon /><span className="ml-2">Você tem <strong>{aReceberVencido}</strong> conta(s) a receber <strong>vencida(s)</strong>.</span></div> )} {/* */}
                        {aPagarVencido > 0 && ( <div onClick={() => onCardClick('pagar_vencidas')} className="flex items-center cursor-pointer hover:underline"><AlertTriangleIcon /><span className="ml-2">Você tem <strong>{aPagarVencido}</strong> conta(s) a pagar <strong>vencida(s)</strong>.</span></div> )} {/* */}
                        {aPagarProximo > 0 && ( <div onClick={() => onCardClick('pagar_proximas')} className="flex items-center cursor-pointer hover:underline"><AlertCircleIcon size={18} /><span className="ml-2">Você tem <strong>{aPagarProximo}</strong> conta(s) a pagar vencendo nos <strong>próximos 7 dias</strong>.</span></div> )} {/* */}
                    </div>
                </div>
            )}

            {/* 3. Cards Principais */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6"> {/* */}
                 <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow"><div className="flex items-center"><div className="p-3 rounded-full bg-green-100 text-green-600 flex-shrink-0"><TrendingUpIcon /></div><div className="ml-4 min-w-0"><p className="text-gray-500 dark:text-gray-400 text-sm">Recebido no Período</p><p className="text-2xl font-bold text-gray-900 dark:text-gray-200 break-words">{formatCurrency(periodReceitas)}</p></div></div></div> {/* */}
                <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow"><div className="flex items-center"><div className="p-3 rounded-full bg-red-100 text-red-600 flex-shrink-0"><TrendingDownIcon /></div><div className="ml-4 min-w-0"><p className="text-gray-500 dark:text-gray-400 text-sm">Pago no Período</p><p className="text-2xl font-bold text-gray-900 dark:text-gray-200 break-words">{formatCurrency(periodDespesas)}</p></div></div></div> {/* */}
                <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow"><div className="flex items-center"><div className="p-3 rounded-full bg-blue-100 text-blue-600 flex-shrink-0"><DollarSignIcon /></div><div className="ml-4 min-w-0"><div className="flex items-center"><p className="text-gray-500 dark:text-gray-400 text-sm">Lucro / Prejuízo</p><Tooltip text="Recebido no período - Pago no período (Operacional)." /></div><p className={`text-2xl font-bold break-words ${periodLucro >= 0 ? 'text-gray-900 dark:text-gray-200' : 'text-red-600'}`}>{formatCurrency(periodLucro)}</p></div></div></div> {/* */}
                <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow"><div className="flex items-center"><div className="p-3 rounded-full bg-purple-100 text-purple-600 flex-shrink-0"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c.06-.32.06-.64 0-.96l-1.68-1.68c-.4-.4-1.04-.4-1.41 0l-1.68 1.68c-.32.32-.32-.82 0 1.14l1.68 1.68c.4.4 1.04.4 1.41 0l1.68-1.68zM3.06 15c-.06.32-.06.64 0 .96l1.68 1.68c.4.4 1.04.4 1.41 0l1.68-1.68c.32-.32.32-.82 0-1.14l-1.68-1.68c-.4-.4-1.04-.4-1.41 0l-1.68 1.68z"/><path d="M12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"/></svg></div><div className="ml-4 min-w-0"><div className="flex items-center"><p className="text-gray-500 dark:text-gray-400 text-sm">Variação de Caixa</p><Tooltip text="(Recebido + Aportes) - (Pago + Retiradas)" /></div><p className={`text-2xl font-bold break-words ${periodCaixa >= 0 ? 'text-gray-900 dark:text-gray-200' : 'text-red-600'}`}>{formatCurrency(periodCaixa)}</p></div></div></div> {/* */}
            </div>

            {/* 4. Limite Anual do MEI */}
            <div className="mb-6 bg-white dark:bg-gray-800 p-6 rounded-lg shadow"> {/* */}
                <div className="flex justify-between items-center mb-2 flex-wrap gap-2"> {/* */}
                     <h3 className="text-lg font-medium dark:text-gray-200">Limite de Faturamento Anual ({year})</h3> {/* */}
                     <span className="font-semibold dark:text-gray-300 text-sm sm:text-base">{formatCurrency(totalReceitasAno)} / {formatCurrency(limiteProporcional)}</span> {/* */}
                </div>
                <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-4"> {/* */}
                     <div
                         className={`h-4 rounded-full transition-all duration-500 ${percentualAtingido > 90 ? 'bg-red-500' : percentualAtingido > 75 ? 'bg-yellow-400' : 'bg-green-500'}`} //
                         style={{ width: `${Math.min(percentualAtingido, 100)}%` }} //
                     ></div>
                </div>
                <p className="text-right text-sm text-gray-500 dark:text-gray-400 mt-2"> {/* */}
                    {percentualAtingido.toFixed(2)}% do limite atingido {/* */}
                </p>
            </div>

            {/* 5. NOVA GRADE: Contas a Pagar / Receber / Meta */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
            
                {/* === CARD A RECEBER ENRIQUECIDO === */}
                <div onClick={() => onCardClick('a_receber')} className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow cursor-pointer hover:shadow-md transition-shadow flex flex-col justify-between">
                    <div>
                        <div className="flex items-center">
                            <div className="p-3 rounded-full bg-green-100 text-green-600 flex-shrink-0"><AlertCircleIcon size={20}/></div>
                            <div className="ml-4 min-w-0">
                                <p className="text-gray-500 dark:text-gray-400 text-sm">A Receber (Total Pendente)</p>
                                <p className="text-2xl font-bold text-gray-900 dark:text-gray-200 break-words">{formatCurrency(aReceber)}</p>
                            </div>
                        </div>
                    </div>
                    {/* Seção de Detalhes Adicionada */}
                    <div className="mt-4 pt-4 border-t dark:border-gray-600 text-sm space-y-2">
                        <div className="flex justify-between items-center text-red-600 dark:text-red-400">
                            <span className="flex items-center"><AlertTriangleIcon /> <span className="ml-2">Vencido</span></span>
                            <span className="font-semibold">{formatCurrency(aReceberVencidoValor)}</span>
                        </div>
                        <div className="flex justify-between items-center text-yellow-600 dark:text-yellow-400">
                            <span className="flex items-center"><AlertCircleIcon size={16} /> <span className="ml-2">Vence (próx. 7 dias)</span></span>
                            <span className="font-semibold">{formatCurrency(aReceberProximoValor)}</span>
                        </div>
                    </div>
                </div>

                {/* === CARD A PAGAR ENRIQUECIDO === */}
                <div onClick={() => onCardClick('a_pagar')} className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow cursor-pointer hover:shadow-md transition-shadow flex flex-col justify-between">
                    <div>
                        <div className="flex items-center">
                            <div className="p-3 rounded-full bg-red-100 text-red-600 flex-shrink-0"><AlertCircleIcon size={20}/></div>
                            <div className="ml-4 min-w-0">
                                <p className="text-gray-500 dark:text-gray-400 text-sm">A Pagar (Total Pendente)</p>
                                <p className="text-2xl font-bold text-gray-900 dark:text-gray-200 break-words">{formatCurrency(aPagar)}</p>
                            </div>
                        </div>
                    </div>
                    {/* Seção de Detalhes Adicionada */}
                    <div className="mt-4 pt-4 border-t dark:border-gray-600 text-sm space-y-2">
                        <div className="flex justify-between items-center text-red-600 dark:text-red-400">
                            <span className="flex items-center"><AlertTriangleIcon /> <span className="ml-2">Vencido</span></span>
                            <span className="font-semibold">{formatCurrency(aPagarVencidoValor)}</span>
                        </div>
                        <div className="flex justify-between items-center text-yellow-600 dark:text-yellow-400">
                            <span className="flex items-center"><AlertCircleIcon size={16} /> <span className="ml-2">Vence (próx. 7 dias)</span></span>
                            <span className="font-semibold">{formatCurrency(aPagarProximoValor)}</span>
                        </div>
                    </div>
                </div>
                
                {/* === Card de Meta (Inalterado) === */}
                {meiInfo.monthlyGoal > 0 && activePeriod !== 'all' && (
                     <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow flex flex-col justify-between">
                         <div className="flex items-center mb-4">
                             <div className="p-3 rounded-full bg-indigo-100 text-indigo-600 flex-shrink-0"><TargetIcon /></div> {/* */}
                             <div className="ml-4 min-w-0">
                                 <p className="text-gray-500 dark:text-gray-400 text-sm">{metaConfig.title}</p> {/* */}
                             </div>
                         </div>
                         <div className="flex items-center justify-around gap-4 my-2">
                             <CircularProgressBar 
                                 percentage={metaConfig.metaPercentual}
                                 colorClass={metaConfig.metaPercentual >= 100 ? "text-green-500" : "text-indigo-500"}
                                 size={120}
                                 strokeWidth={12}
                             />
                             <div className="text-right flex-shrink-0">
                                 <p className="text-2xl font-bold text-gray-900 dark:text-gray-200 break-words">
                                     {formatCurrency(periodReceitas)}
                                 </p>
                                  <p className="text-sm text-gray-500 dark:text-gray-400">
                                     de {formatCurrency(metaConfig.goal)}
                                 </p>
                             </div>
                         </div>
                     </div>
                 )}
            </div>
        </>
    );
};